import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { GetInvitationResData, callGetInvitationApi, callApproveInvitationApi } from 'requests/RequestGroup';
import { HttpStatus } from 'consts/HttpStatus';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from './override.module.scss';

type Props = {};

export const InvitationAgreeTemplate = memo((_props: Props) => {
	const history = useHistory();
	const location = useLocation();
	const search = location.search;
	const queryParams = new URLSearchParams(search);
	const invite_id = queryParams.get('invite_id');

	const [invitation, setInvitation] = useState<GetInvitationResData>(undefined);
	const [getInvitationLoading, setGetInvitationLoading] = useState(true);
	useEffect(() => {
		if (invite_id) {
			const execute = async () => {
				const result = await callGetInvitationApi(invite_id);
				if (result.status !== HttpStatus.OK) {
					setGetInvitationLoading(false);
					setPage(2);
					return;
				}
				setInvitation(result.data);
				setGetInvitationLoading(false);
			};
			execute();
		} else {
			history.push(RoutePath.NOT_FOUND);
		}
	}, [invite_id]);

	const [page, setPage] = useState(0);
	const [isAgreeChecked, setIsAgreeChecked] = useState(true);
	const handleChangeCheckValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setIsAgreeChecked(event.target.checked);
	};
	const [timer, setTimer] = useState(undefined);
	const backToMyPage = () => {
		clearTimeout(timer);
		history.push(RoutePath.MY_PAGE);
	};
	const [approveLoading, setApproveLoading] = useState(false);
	const approveInvitation = async () => {
		setApproveLoading(true);
		// 招待を承認する
		const result = await callApproveInvitationApi({ invite_id });
		if (result.status !== HttpStatus.OK) {
			setApproveLoading(false);
			history.push(RoutePath.ERROR);
			return;
		}
		setApproveLoading(false);

		const timer = setTimeout(function () {
			history.push(RoutePath.MY_PAGE);
		}, 5000);
		setTimer(timer);

		setPage((prev) => prev + 1);
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = '招待への同意';
	}, []);
	return (
		<>
			<Backdrop className={classes.backdrop} open={getInvitationLoading}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>招待への同意</li>
					</ul>
				</div>
				<h1 className="page-head">招待への同意</h1>
				{page === 0 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="section-head">
							<span>{`${invitation?.lastname ?? ''} ${
								invitation?.firstname ?? ''
							}さんから「家族」への招待が来ています`}</span>
						</div>
						<div className="section-txt-box">
							<div className="txt">
								<div>「家族」に所属すると以下の情報が共有されます。</div>
								<ul>
									<li>GakkenID</li>
									<li>メールアドレス</li>
									<li>⽣年⽉⽇</li>
									<li>性別</li>
								</ul>
							</div>
						</div>
						<div className="form-box">
							<div className="form-input">
								<div className="check-box">
									<ul>
										<li>
											<label className={`check-label ${isAgreeChecked ? 'is-active' : ''}`} htmlFor="agree">
												<input type="checkbox" id="agree" checked={isAgreeChecked} onChange={handleChangeCheckValue} />
												上記を確認の上同意する
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="btn-box">
							<div className="btn gr">
								{approveLoading ? (
									<CircularProgress />
								) : (
									<button
										className={!isAgreeChecked ? classes.disabled : ''}
										onClick={approveInvitation}
										disabled={!isAgreeChecked}
									>
										確認
									</button>
								)}
							</div>
						</div>
					</div>
				)}
				{page === 1 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="thankyou-box">
							<img src="images/img-complete.svg" alt="完了しました" />
						</div>
						<p>
							<div>5秒後に自動的にマイページTOPへ戻ります</div>
						</p>
						<div className="btn-box">
							<div className="btn gr">
								<button onClick={backToMyPage}>マイページTOPへ戻る</button>
							</div>
						</div>
					</div>
				)}
				{page === 2 && (
					<div className="section-in">
						<div className="section-txt-box">
							<div className={classes.notFoundTitle}>ただいまの操作はお受けできませんでした。</div>
							<p>無効または期限切れのURLです。</p>
						</div>
					</div>
				)}
			</section>
		</>
	);
});
